import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import excel from 'vue-excel-export'

Vue.config.productionTip = false

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
Vue.use(excel)

import loader from "vue-ui-preloader";

Vue.use(loader);

// https://f3oall.github.io/awesome-notifications/docs/integrations/vue
import VueAWN from "vue-awesome-notifications"
let options = {
		labels: { 
			alert: "Error",
			async: "Cargando",
			confirm: "Confirmación",
			confirmCancel: "Cancelar",
			confirmOk: "Aceptar",
			info: "Información",
			success: "Realizado",
			tip: "tip",
			warning: "Atencion",
		},
		messages: {
			alert: 'Error en la acción requerida',
			success: 'Acción Realizada!!!'
		},
	}

Vue.use(VueAWN, options)

router.beforeResolve((to, from, next) => {
	switch (to.name) {
		case 'Access':
		case 'ChangePassword':
		case 'Unauthorized':
		case 'Logout':
			next()
			break;
		case 'Loading':
			next()
			break;
		default:
			if(localStorage.getItem('token') != null) {
				if(!store.getters.getInitSystem) {
					let path = (localStorage.getItem('redirect') != to.path && localStorage.getItem('redirect') != null) ? localStorage.getItem('redirect') : to.path
					localStorage.setItem('redirect', path)
					next({path: '/loading'})
				} else {
					store.commit('setHistory', {fullPath: to.fullPath, name: to.name, from: from.fullPath})
					next()
				}
			} else {
				localStorage.setItem('redirect', to.path)
				next({path: '/access'})
			}
			break;
	}
})

new Vue({
	router,
	store,
	axios,
	render: function (h) { return h(App) }
}).$mount('#app')